import React from 'react';
import {Typography} from '@mui/material';

export const ReceiptDocumentNote = ({filingType, certificateOfStatus}: {filingType?: string | null; certificateOfStatus?: boolean}) => {
    const note = filingType === 'dissolution' ? 'Includes a Certificate of Dissolution.'
        : certificateOfStatus ? 'Includes a Certificate of Status.' : null;
    return note ? <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>{note}</Typography> : null;
};
